import Vue from "vue"
import './utils/rem.js'
import "./plugins/axios"
import App from "./App.vue"
import router from "./router"
import './assets/css/reset.less'
import VueVideoPlayer from 'vue-video-player'

// require videojs style
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import ReportPlugin from "./plugins/data"; // 文件路径根据项目结构调整
// import Vconsole from 'vconsole';
import "vue-pdf-app/dist/icons/main.css";
import VuePdfApp from "vue-pdf-app";
// new Vconsole()
Vue.component("vue-pdf-app", VuePdfApp);
Vue.use(ReportPlugin);
Vue.use(MintUI)

Vue.use(VueVideoPlayer)
Vue.prototype.$checkViewPass = function(key, value) {
  if (value === '' || value === null || value === undefined) return true;
  const storedValue = localStorage.getItem(key);
  console.log("本地密码",storedValue)
  return storedValue === String(value); // 将 value 转为字符串进行比较（与 localStorage 的存储格式一致）
};
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app")
